import { Stack } from '@mantine/core';
import FileItem from '@/pages/AutomationPage/components/ManualRunModal/components/FileItem';
import type { RelativeFile } from '@/types/common';
import CustomDropZone from '@/components/CustomDropZone';

type Props = {
  file?: RelativeFile;
  setFile: (f?: RelativeFile) => void;
};

export default function UploadSingleFile({ file, setFile }: Props) {
  return (
    <Stack gap="xs">
      {file ? (
        <FileItem name={file.path} size={file.file.size} onDelete={() => setFile(undefined)} />
      ) : (
        <CustomDropZone mode="single" setFiles={(arr) => setFile(arr[0])} />
      )}
    </Stack>
  );
}
